'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002ecrud$0024$002dDelete$002dDialog from "./presto.crud$-Delete-Dialog.js";
import * as $j_presto$002etypes$0024proto$0024$002dDelete$002dTwo$002dFactor$002dAuth$002dRequest from "./presto.types$proto$-Delete-Two-Factor-Auth-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19(item$4, outer) {
  this.bKM = null;
  this.a9H = null;
  this.bKM = item$4;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.a9H = new $j_presto$002ecrud$0024$002dDelete$002dDialog.$c_Lpresto_crud$DeleteDialog("remover 2fa");
}
export { $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19 as $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19 };
$p = $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19() {
}
export { $h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19 as $h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19 };
$h_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19.prototype = $p;
$p.bU = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$();
  var t = this.bKM.e4.jk;
  return $x_1.au(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $j_presto$002etypes$0024proto$0024$002dDelete$002dTwo$002dFactor$002dAuth$002dRequest.$c_Lpresto_types$proto$DeleteTwoFactorAuthRequest(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f))));
});
$p.bS = (function() {
  return this.a9H.n3;
});
$p.bF = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_state_Val$().au(this.a9H.b2());
});
var $d_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19, "presto.TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19", ({
  TP: 1,
  J: 1
}));
export { $d_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19 as $d_Lpresto_TwoFactorAuthView$DeleteTwoFactorAuth$$anon$19 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Delete-Two-Factor-Auth$$anon$19.js.map
